// extracted by mini-css-extract-plugin
export default {"wrapper":"iconButtonWithBadge_wrapper__t80pe","badgeWrapper":"iconButtonWithBadge_badgeWrapper__dOsE3"};